import { BarChartSpec, CalculationType, ModeOption, SortOption, UnitOptions } from '@/core';
import { OptionsEditorProps } from '@/plugin-system';

export const DEFAULT_CALCULATION: CalculationType = 'LastNumber';
export const DEFAULT_UNIT: UnitOptions = { kind: 'Decimal', abbreviate: true };
export const DEFAULT_SORT: SortOption = 'desc';
export const DEFAULT_MODE: ModeOption = 'value';

export type BarChartOptionsEditorProps = OptionsEditorProps<BarChartSpec>;

/**
 * Creates the initial/empty options for a BarChart panel.
 */
export function createInitialBarChartSpec(): BarChartSpec {
  return {
    unit: DEFAULT_UNIT,
    sort: DEFAULT_SORT,
    mode: DEFAULT_MODE,
  };
}
